import { createContext } from 'react';

export const MetricsContext = createContext({
  getCurrentTopOffSet: () => { },
  breakPointOffSets: [],
  addResizeCallback: () => { },
});
